import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpBackend, HttpClientModule} from '@angular/common/http';
import {MissingTranslationHandler, TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslationConfig} from './translation.config';
import {
  ExtendedTranslateLoaderService,
  ExtendedTranslateService,
  MissingTranslationHandlerService,
  MissingTranslationSaverService
} from './services';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: ExtendedTranslateLoaderService,
        deps: [HttpBackend, TranslationConfig],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MissingTranslationHandlerService,
        deps: [MissingTranslationSaverService],
      },
    }),
  ],
  providers: [
    MissingTranslationSaverService,
    {provide: TranslateService, useClass: ExtendedTranslateService},
  ],
})
export class TranslationRootModule {
}
